import React from 'react'
import { Pane } from 'evergreen-ui'
export const Text = ({ field }) => {
    return <Pane></Pane>
} 